import React from 'react';
import { Box, Button } from '@mui/material';
import { useParams } from 'react-router-dom';
import { parseIntoNumber } from '../../utilities/helper';
import BidWidget from '../../components/widgets/bid.widget';
import useNavigateHook from '../../hooks/navigate.hook';

const MyAccountAuctionDetailPage: React.FC = () => {
  const { doNavigate } = useNavigateHook();
  const { auction_id } = useParams<{ auction_id: string }>();

  return (
    <>
      <Box sx={{ mb: 4 }}>
        <Button variant="outlined" color="info" onClick={() => doNavigate(`/my-account/auctions`)}>
          Back To Auction List
        </Button>
      </Box>
      <Box sx={{ my: 4, mx: 'auto' }}>
        <BidWidget auction_id={parseIntoNumber(auction_id)} allowPlaceBid={false} viewType="seller" />
      </Box>
    </>
  );
};

export default MyAccountAuctionDetailPage;
